import { ITextFilter } from "../../models/busqueda/text-filter.model";

export const TEXT_FILTER: ITextFilter = {
    textBusquedaGeneral: 'Búsqueda general',
    textYearDocumento: 'Año del documento',
    textNumeroExpediente : 'Número de registro',
    textNumeroDocumento : 'Número documento',
    textOrigen : 'Origen',
    textArea : 'Origen emisión > área',
    textAreaActual : 'Ubicación actual > área',
    textAreaRecibido : 'U. histórica > rec. > área',
    textAreaEnviado : 'U. histórica > env. > área',
    textPersonaAutora : 'Origen emisión > persona autora',
    textPersonaActual : 'Ubicación actual > persona',
    textPersonaRecibido : 'U. histórica > recibido por',
    textPersonaEnviado : 'U. histórica > enviador por',
    textAdministrado : 'Origen recepción > Administrado',
    textEtiqueta : 'Asunto',
    textArchivoPrincipal : 'Archivo principal firmado',
    textCreacionDesde : 'Fecha creación > desde',
    textCreacionHasta : 'Fecha creación > hasta'
}















